import React, {Component} from "react";
import { Link, Navigate } from "react-router-dom";

import Slider from "react-slick";

import axiosBaseURL from "../httpCommon";

class Home extends Component{
  constructor(props){
        super();
        this.state={
            sliders: [],
            brands: [],
            organizations: [],

            loggedIn: window.localStorage.getItem("isLoggedIn"),
            authUser: JSON.parse(window.localStorage.getItem("userData"))
        }
    }

    async componentDidMount(){

        await axiosBaseURL.get('api/v1/home', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.state.authUser.token
            }
        })
            .then(response => {
                if (response.data.status === 200) {
                    this.setState({
                        sliders: response.data.sliders,
                        brands: response.data.brands,
                        organizations: response.data.organizations
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    onLogoutHandler=()=>{
        axiosBaseURL.get('api/v1/logout')
            .then(response=>{
                window.localStorage.clear();
                this.setState({loggedIn: false})
                this.refreshPage();
            })
            .catch(error=>{
                console.log(error);
            })
    }
    refreshPage=()=> {
        window.location.reload(false);
    }

    render(){
      if(!this.state.loggedIn === true){
          return <Navigate to ="/login"/>
      }
      
            
      const printSliders = this.state.sliders.map((slider, key) => {
          return <div key={key}>
              <div>
                  <div className="slider-box">
                      <img src={slider} className="img-fluid bg-img" alt=""/>
                  </div>
              </div>
          </div>
      });

      const printBrands = this.state.brands.map((brand, key) => {
          return <div key={key}>
              <div>
                  <a className="brand-box" href="/">
                      <img src={brand} className="img-fluid" alt=""/>
                  </a>
              </div>
          </div>
      });

      const allOrganizations = this.state.organizations
          const printOrganizations = allOrganizations.map((allOrganization, key) => {
              return <div key={key}>
                  <div className="col-12">
                      <div className="product-inline">
                          <Link to={"/organization/" + allOrganization.id}>
                              <img src={allOrganization.picture} className="img-fluid" alt=""/>
                          </Link>
                          <div className="product-inline-content">
                              <div>
                                  <Link to={"/organization/" + allOrganization.id}>
                                      <h4>{allOrganization.name}</h4>
                                  
                                  <h5>{allOrganization.address}</h5>
                                  </Link>
                              </div>
                          </div>
                    </div>
                </div>
                <div className="divider"></div>
          </div>
      });

      const settings = {
          dots: false,
          infinite: true,
          slidesToShow: 1.2,
          slidesToScroll: 1
      }

      const brandSettings = {
          dots: false,
          infinite: true,
          autoStart: true,
          slidesToShow: 3.1,
          slidesToScroll: 1
      }

      return(
        <>
          <header>
            <Link href="/" className="brand-logo">
              <img src="/logo.jpg" className="img-fluid" alt="" width="125" height="auto"/>
            </Link>
          </header>

          <section className="pt-0 home-section top-space ratio_55">
            <div className="home-slider slick-default theme-dots">
              <Slider {...settings}>
                  {printSliders}
              </Slider>
            </div>
          </section>


  <section className="deals-section px-15 pt-0">
    <div className="title-part">
      <h2>My Organizations</h2>
    </div>
    <div className="product-section">
      <div className="row gy-3">
        
        {printOrganizations}

      </div>
    </div>
  </section>


 
  <section className="brand-section pl-15">
    <h2 className="title">Our Leading Brands</h2>
    <div className="brand-slider slick-default">

      <Slider {...brandSettings}>
          {printBrands}
      </Slider>

    </div>
  </section>
  <div className="divider"></div>


  <section className="panel-space"></section>


  <div className="bottom-panel">
    <ul>
      <li>
        <a onClick={this.onLogoutHandler}>
          <div className="icon">
            <i className="iconly-Profile icli"></i>
            <i className="iconly-Profile icbo"></i>
          </div>
          <span>Logout</span>
        </a>
      </li>
    </ul>
  </div>
        </>
      )
    }
}
export default Home;